import { render, staticRenderFns } from "./create-trainee.vue?vue&type=template&id=1a57232f&scoped=true&"
import script from "./create-trainee.vue?vue&type=script&lang=js&"
export * from "./create-trainee.vue?vue&type=script&lang=js&"
import style0 from "./create-trainee.vue?vue&type=style&index=0&id=1a57232f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a57232f",
  null
  
)

export default component.exports